export default {
  PleaseSelectUser: '请选择客户',
  OnlyCrossBorder: '只查看跨境链路',
  CrossBorderLink: '跨境链路',
  CrossBorderNode: '跨境节点',
  NetTips:
    '您可在列表对单个网关进行快捷组网管理，图形模式支持批量修改。\n特别提醒：关闭组网功能，将可能影响关联的策略，导致策略、配置失效 ，请谨慎操作！ 如有疑问，可先咨询我司运维工程师再进行操作。',
  DirectPOP: '直连POP',
  CPEInformation: 'CPE信息',
  name: '名称',
  model: '型号',
  peerGateway: '对端网关',
  NetworkDetail: '组网详情',
  nodePlaceholder: '点击查看CPE及POP信息',
  WhetherToUse: '是否使用',
  NoneCpeIPTips: '（因配置dhcp/pppoe无法获取）',
  LocalCPE: '本端CPE',
  DirectlyConnectedNode: '直连节点',
  NodeIp: '节点IP',
  PeerCPE: '对端CPE',
  EnableAllConfirmTitle: '确定开启全部分支的组网功能',
  EnableAllConfirmContent: '开启后将恢复所有组网分支的sdwan服务，恢复分支组网连接',
  EnableBatchConfirmTitle: (n: number) => `确定批量开启${n}个分支的组网功能`,
  EnableBatchConfirmContent: '开启后将恢复分支的sdwan服务，恢复分支组网连接',
  EnableSuccess: '开启成功',
  DisableAllConfirmTitle: '确定关停该用户的组网功能',
  DisableAllConfirmContent: '关闭后用户SDWAN服务将关停，所有分支组网连接断开，请确认业务影响后再操作',
  DisableBatchConfirmTitle: (n: number) => `确定批量关停${n}个分支的组网功能`,
  DisableBatchConfirmContent: '关闭后将导致断开与其他网关的全部连接，请确认业务影响后再操作',
  DisableSuccess: '关停成功',
}